<template>
  <div>
    <b-card id="listEventos" no-body class="pt-1">
      <div>
        <b-row class="mb-1">
          <b-col cols="12" md="12">
            <b-button
                id="update"
                variant="primary"
                @click="traerAsignaciones"
                :disabled="loading"
                v-b-tooltip.hover="'Actualizar data'"
                class="mx-1"
                size="sm"
            >
              <span v-if="loading"
              ><b-spinner style="width: 15px; height: 15px"
              /></span>
              <span v-else><feather-icon icon="RefreshCwIcon" /></span>
            </b-button>
            <b-button
                variant="primary"
                @click="descargarPlantillaExcel"
                v-b-tooltip.hover="'Descargar Plantilla Excel'"
                size="sm"
                class="mr-1"
            >
              <span>
                <font-awesome-icon icon="fa-solid fa-file-excel"/>
              </span>
            </b-button>
            <b-button
                variant="primary"
                @click="descargarPlantillaPDF"
                v-b-tooltip.hover="'Descargar PDF'"
                size="sm"
            >
              <span>
                <font-awesome-icon icon="fa-solid fa-file-pdf"/>
              </span>
            </b-button>
          </b-col>
        </b-row>
      </div>
      <b-col cols="12" class="mt-0 pt-0">
        <hot-table ref="hotTableEntregas" :data="itemsAsignaciones" licenseKey='non-commercial-and-evaluation' ></hot-table>
      </b-col>
    </b-card>

    <b-modal
        id="modal-prevent-closing"
        v-model="estadoModal"
        ref="my-modal"
        title="Registrar Evento"
        ok-title="Registrar"
        cancel-title="Cancelar"
        cancel-variant="outline-secondary"
        :size="loading2 ? 'md' : 'lg'"
        :cancel-disabled="loading2"
        :ok-disabled="loading2"
        centered
        no-close-on-esc
        no-close-on-backdrop
        @ok="handleOk"
        @show="resetModal"
    >
      <div v-if="loading2" align="center">
        <p>Registrando ...</p>
        <b-spinner label="Loading..." variant="primary" />
        <br />
        <br />
        <p><b>No cierres esta ventana hasta que el proceso termine.</b></p>
      </div>
      <validation-observer v-else ref="formularioEvento" #default="{ invalid }">
        <b-form autocomplete="off" @submit.prevent="handleSubmit">
          <b-row>
            <b-col lg="6">
              <b-form-group label="Evento" label-for="evento">
                <validation-provider
                    #default="{ errors }"
                    name="Evento"
                    vid="evento"
                    rules="required"
                >
                  <b-form-input
                      id="evento"
                      v-model="evento"
                      :state="errors.length > 0 ? false : null"
                      name="evento"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col lg="6">
              <b-form-group label="Descripción" label-for="descripcion">
                <validation-provider
                    #default="{ errors }"
                    name="Descripción"
                    vid="descripcion"
                    rules="required"
                >
                  <b-form-input
                      id="descripcion"
                      v-model="descripcion"
                      :state="errors.length > 0 ? false : null"
                      name="descripcion"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col lg="4">
              <b-form-group label="Fecha Inicio" label-for="fecha_inicio">
                <validation-provider
                    #default="{ errors }"
                    name="Fecha Inicio"
                    vid="fecha_inicio"
                    rules="required"
                >
                  <b-form-datepicker
                      id="fecha_inicio"
                      v-model="fecha_inicio"
                      :date-format-options="{
                      year: 'numeric',
                      month: '2-digit',
                      day: '2-digit',
                    }"
                      :hide-header="true"
                      start-weekday="1"
                      v-bind="labels || {}"
                      today-button
                      reset-button
                      close-button
                      :state="errors.length > 0 ? false : null"
                      name="fecha_inicio"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col lg="4">
              <b-form-group label="Fecha Fin" label-for="fecha_fin">
                <validation-provider
                    #default="{ errors }"
                    name="Fecha Fin"
                    vid="fecha_fin"
                    rules="required"
                >
                  <b-form-datepicker
                      id="fecha_fin"
                      v-model="fecha_fin"
                      :date-format-options="{
                      year: 'numeric',
                      month: '2-digit',
                      day: '2-digit',
                    }"
                      :hide-header="true"
                      start-weekday="1"
                      v-bind="labels || {}"
                      today-button
                      reset-button
                      close-button
                      :state="errors.length > 0 ? false : null"
                      name="fecha_fin"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col lg="4">
              <b-form-group label="N° de Premios" label-for="n_premios">
                <validation-provider
                    #default="{ errors }"
                    name="N° de Premios"
                    vid="n_premios"
                    rules="required"
                >
                  <b-form-input
                      id="n_premios"
                      v-model="n_premios"
                      :state="errors.length > 0 ? false : null"
                      name="n_premios"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col lg="12" class="mb-1 mt-1">
              Perfil del colaborador que participará en el evento:
            </b-col>
          </b-row>
          <b-row>
            <b-col lg="5">
              <b-form-group label="Tipo" label-for="tipo">
                <validation-provider
                    #default="{ errors }"
                    name="Tipo"
                    vid="tipo"
                    rules="required"
                >
                  <v-select
                      id="tipo"
                      v-model="tipo"
                      :options="tipoLista"
                      label="nombre_tipo_planilla"
                      placeholder="Seleccionar tipo..."
                      multiple
                      @input="cambiarTipo"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col lg="7" v-if="opcionBool">
              <b-form-group label="Opción" label-for="opcion">
                <validation-provider
                    #default="{ errors }"
                    name="Opción"
                    vid="opcion"
                    rules="required"
                >
                  <v-select
                      id="tipo"
                      v-model="opcion"
                      :options="opcionLista"
                      label="nombre_opcion_planilla"
                      placeholder="Seleccionar opcion..."
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col :lg="opcionBool ? '12' : '7'">
              <b-form-group label="Sede" label-for="sede">
                <validation-provider
                    #default="{ errors }"
                    name="Sede"
                    vid="sede"
                    rules="required"
                >
                  <v-select
                      id="sede"
                      v-model="sede"
                      :options="sedeLista"
                      label="sede"
                      placeholder="Seleccionar sede..."
                      multiple
                      @input="cambiarSede"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col lg="6">
              <b-form-group label="Género" label-for="genero">
                <validation-provider
                    #default="{ errors }"
                    name="Género"
                    vid="genero"
                    rules="required"
                >
                  <v-select
                      id="genero"
                      v-model="genero"
                      :options="generoLista"
                      label="genero"
                      placeholder="Seleccionar genero..."
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col lg="6">
              <b-form-group label="Hijos" label-for="hijos">
                <validation-provider
                    #default="{ errors }"
                    name="Hijos"
                    vid="hijos"
                    rules="required"
                >
                  <v-select
                      id="hijos"
                      v-model="hijos"
                      :options="hijosLista"
                      label="asignacion_familiar"
                      placeholder="Seleccionar hijos..."
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
          </b-row>
        </b-form>
      </validation-observer>
    </b-modal>
    <b-modal
        id="modal-fotos"
        v-model="estadoModalFotos"
        ref="modal-fotos"
        title="Evidencias"
        ok-title="Cerrar"
        ok-only
        size="xl"
        scrollable
        no-close-on-esc
        no-close-on-backdrop
        @ok=""
        @show=""
    >
      <div align="center">
        ...
      </div>
    </b-modal>
    <b-modal
        id="modal-confirmar"
        v-model="estadoModalConfirmar"
        ref="modal-confirmar"
        :title="tituloConfirmar"
        ok-title="Aceptar"
        cancel-title="Cancelar"
        cancel-variant="outline-secondary"
        size="sm"
        centered
        no-close-on-esc
        no-close-on-backdrop
        @ok=""
        @show=""
    >
      <div align="center">
        <p>Por favor, confirmar acción</p>
      </div>
    </b-modal>
  </div>
</template>

<script>
import axiosIns from "../../libs/axios";
import {
  BBadge,
  BButton,
  BCard,
  BCardBody,
  BCol,
  BForm,
  BFormDatepicker,
  BFormGroup,
  BFormInput,
  BFormSelect, BImg,
  BInputGroup,
  BInputGroupAppend,
  BPagination,
  BRow,
  BSpinner,
  BTable,
  VBModal,
  VBTooltip,
} from 'bootstrap-vue'
import { localize, ValidationObserver, ValidationProvider } from "vee-validate";
import { required } from "@validations";
import { HotTable } from '@handsontable/vue'
import { registerAllModules } from 'handsontable/registry'
import { esMX, registerLanguageDictionary } from 'handsontable/i18n'

import 'handsontable/dist/handsontable.full.css'
import vSelect from "vue-select";
import { SwiperSlide } from 'vue-awesome-swiper'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

registerAllModules();
registerLanguageDictionary(esMX);

export default {
  components: {
    SwiperSlide,
    BImg,
    BCard,
    BCardBody,
    BRow,
    BCol,
    BButton,
    BForm,
    BInputGroup,
    BFormGroup,
    BFormInput,
    BFormSelect,
    BInputGroupAppend,
    BTable,
    BPagination,
    BBadge,
    BSpinner,
    BFormDatepicker,
    vSelect,
    HotTable,

    ValidationProvider,
    ValidationObserver,
  },
  directives: {
    "b-modal": VBModal,
    "b-tooltip": VBTooltip,
  },
  data() {
    return {
      totalRows: 0,
      estadoModal: false,
      estadoModalConfirmar: false,
      tituloConfirmar: null,
      itemsAsignaciones: [],
      loading: false,
      loading2: false,
      loadingEditar: false,
      status: [
        {
          0: "Pendiente",
          1: "Realizado",
          2: "Cancelado",
        },
        {
          0: "light-warning",
          1: "light-success",
          2: "light-danger",
        },
      ],

      labels: {
        labelPrevDecade: "Década anterior",
        labelPrevYear: "Año anterior",
        labelPrevMonth: "Mes anterior",
        labelCurrentMonth: "Mes actual",
        labelNextMonth: "Mes siguiente",
        labelNextYear: "Año siguiente",
        labelNextDecade: "Década siguiente",
        labelToday: "Hoy",
        labelSelected: "Fecha seleccionada",
        labelNoDateSelected: "Seleccione fecha",
        labelCalendar: "Calendario",
        labelNav: "Navegación por calendario",
        labelHelp: "Use las teclas de flecha para navegar por el calendario",
        labelTodayButton: "Hoy",
        labelResetButton: "Borrar",
        labelCloseButton: "Cerrar",
      },

      evento: null,
      n_premios: null,
      descripcion: null,
      fecha_inicio: null,
      fecha_fin: null,

      genero: null,
      generoLista: [],

      hijos: null,
      hijosLista: [],

      tipo: null,
      tipoLista: [],

      sede: null,
      sedeLista: [],

      opcion: null,
      opcionLista: ["TODOS", "CALIFICADOS", "NO CALIFICADOS"],
      opcionBool: false,

      estadoEditarSelected: null,
      estadosEditar: [
        "EN PROCESO",
        "CERRADO",
        "CANCELADO",
      ],

      tableAsignaciones: null,
      settingsAsignaciones: null,
      estadoModalFotos: false,
      required,
    };
  },
  computed: {},
  mounted() {
    this.tableAsignaciones = this.$refs.hotTableEntregas.hotInstance;
    localize("es");
    this.traerAsignaciones();
  },
  methods: {
    traerAsignaciones() {
      const yo = this;
      yo.loading = true;
      yo.tableAsignaciones.updateData([])

      const config = {
        method: 'get',
        url: '/bbss/absentismos/asignacion_familiar/'
      };

      axiosIns(config)
          .then(function (response) {
            if (response.status === 200) {
              yo.itemsAsignaciones = response.data;
              yo.totalRows = yo.itemsAsignaciones.length;
              yo.settingsAsignaciones = {
                width: '100%', //Ancho
                height: '59vh', //Alto
                rowHeaders: true,
                colHeaders: [
                  'ID',
                  'ESTADO',
                  'CODIGO SAP',
                  'DNI',
                  'NOMBRES',
                  'CARGO',
                  'SEDE',
                  'FECHA INICIO',
                  'FECHA FIN',
                  'N° DERECHOHABIENTE',
                  'EVALUADOR',
                  'FECHA CREACION'
                ],
                columns: [
                  {
                    data: 'id',
                    type: 'numeric',
                  },
                  {
                    data: 'estado',
                    editor: 'select',
                    selectOptions: [],
                    allowInvalid: false,
                    renderer(instance, td, row, col, prop, value, cellProperties) {

                      const spd = value === '1' ? 'light-warning' : value === '3' ? 'light-success' : 'light-danger'
                      const spd2 = value === '1' ? 'En Proceso' : value === '3' ? 'Validado' : 'Desaprobado'
                      td.className = 'htCenter htMiddle'
                      td.innerHTML = '<b-badge class="badge badge-'+ spd +'">'+ spd2 +'</b-badge>'

                      return td
                    }
                  },
                  {
                    data: 'cod_sap',
                    type: 'text',
                    className: 'htMiddle htCenter',
                  },
                  {
                    data: 'dni',
                    type: 'text',
                    className: 'htMiddle htCenter',
                  },
                  {
                    data: 'nombres',
                    type: 'text',
                    className: 'htMiddle',
                  },
                  {
                    data: 'puesto',
                    type: 'text',
                    className: 'htMiddle',
                  },
                  {
                    data: 'sede',
                    type: 'text',
                    className: 'htMiddle',
                  },
                  {
                    data: 'fecha_inicio',
                    type: 'date',
                    dateFormat: 'YYYY-MM-DD',
                    className: 'htCenter htMiddle',
                  },
                  {
                    data: 'fecha_fin',
                    type: 'date',
                    dateFormat: 'YYYY-MM-DD',
                    className: 'htCenter htMiddle',
                  },
                  {
                    data: 'n_derechohabiente',
                    type: 'text',
                    className: 'htMiddle htCenter',
                  },
                  {
                    data: 'nombre_evaluador',
                    type: 'text',
                    className: 'htMiddle',
                  },
                  {
                    data: 'date_created',
                    type: 'date',
                    dateFormat: 'YYYY-MM-DD',
                    className: 'htCenter htMiddle',
                  },
                ],
                contextMenu: {
                  items: {
                    aprobar: {
                      name: "Aprobar",
                      callback: function () {
                        const rowData = this.getDataAtRow(this.getSelected()[0][0])
                        if(rowData[1] === '1'){
                          yo.confirmar('¿Aprobar registro?')
                        }
                      },
                    },
                    desaprobar: {
                      name: "Desaprobar",
                      callback: function () {
                        const rowData = this.getDataAtRow(this.getSelected()[0][0])
                        if(rowData[1] === '3'){
                          yo.confirmar('¿Desaprobar registro?')
                        }
                      },
                    },
                    derecho: {
                      name: "Ver Derechohabiente",
                      callback: function () {
                        const rowData = this.getDataAtRow(this.getSelected()[0][0])
                        yo.verEvidencia()
                      },
                    },
                    view: {
                      name: "Ver Evidencia",
                      callback: function () {
                        const rowData = this.getDataAtRow(this.getSelected()[0][0])
                        yo.verEvidencia()
                      },
                    },
                  },
                },
                bindRowsWithHeaders: true,
                readOnly: true,
                dropdownMenu: ['filter_by_condition', 'filter_by_value', 'filter_action_bar'], // Activar menú
                filters: true,// Activar Filtro
                columnSorting: true, // Ordenar por columna
                manualColumnResize: true,
                hiddenColumns: {
                  columns: [0, 1],
                  indicators: false
                },
                language: esMX.languageCode,
                locale: "es-MX",
                stretchH: 'all',
                // fixedColumnsStart: 1,
              }

              yo.tableAsignaciones.updateData(yo.itemsAsignaciones)
              yo.tableAsignaciones.updateSettings(yo.settingsAsignaciones)
            }
          })
          .catch(function (error) {
            console.log(error);
          })
          .finally(function () {
            yo.loading = false;
          })


    },
    abrirModalCrear() {
      const yo = this;
      yo.estadoModal = true;
    },
    handleOk(bvModalEvt) {
      // Prevent modal from closing
      bvModalEvt.preventDefault();
      // Trigger submit handler
      this.handleSubmit();
    },
    handleSubmit() {
      const yo = this;
      this.$refs.formularioEvento.validate().then((success) => {
        if (success) {
          yo.loading2 = true;

          const data = JSON.stringify({
            nombre: yo.evento,
            descripcion: yo.descripcion,
            observacion: "",
            fecha_inicio: yo.fecha_inicio,
            fecha_fin: yo.fecha_fin,
            anio: yo.fecha_inicio.split("-")[0],
            tipo: yo.tipo.map((opcion) => opcion.key_tipo_planilla),
            tipostatic: yo.tipoListaStatic
                .filter((invoice) => invoice.key_tipo_planilla !== "TODOS")
                .map((opcion) => opcion.key_tipo_planilla),
            sede: yo.sede.map((opcion) => opcion.key_sede),
            sedestatic: yo.sedeListaStatic
                .filter((invoice) => invoice.key_sede !== "TODOS")
                .map((opcion) => opcion.key_sede),
            opcion: yo.opcion,
            genero: yo.genero.genero,
            hijos: yo.hijos.asignacion_familiar,
            n_premios: yo.n_premios,
            estado: "0",
            con_usuario: yo.getUserID(),
          });

          const config = {
            method: "post",
            url: "evento/registrar/",
            headers: {
              "Content-Type": "application/json",
            },
            data: data,
          };
        }
      });
    },
    resetModal() {
      this.evento = null;
      this.descripcion = null;
      this.fecha_inicio = null;
      this.fecha_fin = null;
      this.genero = null;
      this.hijos = null;
      this.tipo = null;
      this.sede = null;
      this.opcion = null;
      this.n_premios = null;
      this.opcionBool = false;
    },
    verEvidencia(){
      const yo = this;
      yo.estadoModalFotos = true;
    },
    descargarPlantillaExcel() {
      const yo = this
      const arrays = yo.tableAsignaciones.getData()
      const data_new = arrays.map(a => a[0])

      const data = JSON.stringify({
        'ids': data_new
      })

      const config = {
        method: 'post',
        url: '/bbss/asignaciones/exportar/',
        headers: {
          'Content-Type': 'application/json'
        },
        responseType: 'arraybuffer',
        data: data
      }

      axiosIns(config)
          .then(function (response) {
            if (response.status === 200) {

              const fileURL = window.URL.createObjectURL(
                  new Blob([response.data])
              )
              const fileLink = document.createElement('a')
              fileLink.href = fileURL

              fileLink.setAttribute(
                  'download',
                  'asignaciones.xlsx'
              )
              document.body.appendChild(fileLink)
              fileLink.click()

              yo.$toast(
                  {
                    component: ToastificationContent,
                    props: {
                      title: 'Archivo creado',
                      icon: 'CheckIcon',
                      text: 'El archivo se creó satisfactoriamente.',
                      variant: 'success',
                    },
                  },
                  {
                    position: 'top-center',
                  }
              )

            }
          })
          .catch(function (error) {
            console.log(error)
            yo.$toast({
              component: ToastificationContent,
              props: {
                title: 'Error en la creación del archivo',
                icon: 'XIcon',
                text: 'Hubo un error en la creación del archivo, intentelo nuevamente en unos minutos.',
                variant: 'danger',
              },
            })
          })
          .finally(function () {

          })

      /*
      const fileURL = window.URL.createObjectURL(new Blob([]));
      console.log(fileURL);
      const fileLink = document.createElement('a');
      fileLink.href = fileURL;
      fileLink.setAttribute('download', "Registro Masivo para Absentismo.xlsx");
      document.body.appendChild(fileLink);
      fileLink.click();
      */
    },
    descargarPlantillaPDF() {

      const yo = this
      const arrays = yo.tableAsignaciones.getData()
      const data_new = arrays.map(a => a[0])

      const data = JSON.stringify({
        'ids': data_new,
      })

      const config = {
        method: 'post',
        url: '/bbss/asignaciones/exportar/pdf/',
        headers: {
          'Content-Type': 'application/json'
        },
        responseType: 'arraybuffer',
        data: data
      }

      axiosIns(config)
          .then(function (response) {
            if (response.status === 200) {

              const fileURL = window.URL.createObjectURL(
                  new Blob([response.data])
              )
              const fileLink = document.createElement('a')
              fileLink.href = fileURL

              fileLink.setAttribute(
                  'download',
                  'asignaciones.zip'
              )
              document.body.appendChild(fileLink)
              fileLink.click()

              yo.$toast(
                  {
                    component: ToastificationContent,
                    props: {
                      title: 'Archivo creado',
                      icon: 'CheckIcon',
                      text: 'El archivo se creó satisfactoriamente.',
                      variant: 'success',
                    },
                  },
                  {
                    position: 'top-center',
                  }
              )

            }
          })
          .catch(function (error) {
            console.log(error)
            yo.$toast({
              component: ToastificationContent,
              props: {
                title: 'Error en la creación del archivo',
                icon: 'XIcon',
                text: 'Hubo un error en la creación del archivo, intentelo nuevamente en unos minutos.',
                variant: 'danger',
              },
            })
          })
          .finally(function () {

          })

      /*
      const fileURL = window.URL.createObjectURL(new Blob([]))
      console.log(fileURL)
      const fileLink = document.createElement('a')
      fileLink.href = fileURL
      fileLink.setAttribute('download', 'Reporte de Absentismo.zip')
      document.body.appendChild(fileLink)
      fileLink.click()
      */
    },
    confirmar(titulo){
      const yo = this
      yo.tituloConfirmar = titulo
      yo.estadoModalConfirmar = true
    },
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";

.alinear-una-sola-linea {
  white-space: nowrap !important;
}
.min-400 {
  min-width: 350px !important;
}
.alinear-medio {
  vertical-align: middle !important;
}
</style>
